import script from "./outbound-control-log-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./outbound-control-log-list.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__